import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import Button from './Button'
import { getCaretPosition, setCaretPosition } from '@aytm/app/insights/dashboard/lib/interaction'
import { truncateStringToLength } from '@aytm/app/insights/dashboard/lib/strings'
import { decode, encodeAll } from '@aytm/app/insights/dashboard/lib/sanitize'

const Tag = props => {
  const tag = props.tag || ''
  const add = props.add || false
  const wait = props.wait || false
  const [edit, setEdit] = useState(false)
  const editor = useRef()
  const caret = useRef(0)

  const getValue = useRef()
  getValue.current = () => encodeAll(editor.current ? editor.current.innerText : '')

  const setValue = useRef()
  setValue.current = value => {
    if (editor.current) {
      const val = undefined === value || null === value ? '' : `${value}`
      editor.current.innerText = decode(val)
      if (val.length < caret.current) {
        setCaretPosition(editor.current, caret.current)
      }
    }
  }

  const onDelete = event => {
    if (props.onUpdate) {
      props.onUpdate({ ...event, index: props.index })
    }
  }

  const onKeyDown = event => {
    const maxLength = 255
    const val = getValue.current().trim()
    if (edit) {
      if ('Enter' === event.key) {
        event.preventDefault()
        const value = truncateStringToLength(val, maxLength, '')
        if ('' !== value) {
          props.onUpdate({ action: 'add', tag: value })
          setValue.current('')
        }
      } else {
        if (['Backspace', 'Delete'].includes(event.key) || (/[\w -@]/.test(event.key) && val?.length < maxLength)) {
          caret.current = getCaretPosition(editor.current)
        } else {
          event.preventDefault()
        }
      }
    }
  }

  const onFocus = () => {
    if (props.editing) {
      setEdit(true)
    }
  }

  const onBlur = () => {
    setEdit(false)
  }

  useEffect(() => {
    if (add && wait && tag !== getValue.current()) {
      setValue.current(tag)
    }
  }, [add, wait, tag])

  useEffect(() => {
    if (!add && editor.current && editor.current !== document.activeElement && tag !== getValue.current()) {
      setValue.current(tag)
    }
  }, [add, tag])

  return add ? (
    <div className={`${props.className} ${props.className}-add`}>
      {props.wait ? (
        <div
          className={`${props.className}-text ${props.className}-text-add ${props.className}-text-add-wait`}
          ref={editor}
          placeholder={props.placeholder}
        />
      ) : (
        <div
          className={`${props.className}-text ${props.className}-text-add`}
          ref={editor}
          tabIndex={1}
          contentEditable={true}
          placeholder={props.placeholder}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}
    </div>
  ) : (
    <div className={`${props.className} ${props.className}-item`} style={props.style}>
      <div
        className={`${props.className}-text  ${props.className}-text-item`}
        ref={editor}
        tabIndex={1}
        contentEditable={!props.wait && edit}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {props.wait ? null : (
        <Button className={`${props.className}-button`} action={'delete'} wait={wait} onClick={onDelete} />
      )}
    </div>
  )
}

Tag.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  tag: PropTypes.string,
  index: PropTypes.number,
  wait: PropTypes.any,
  add: PropTypes.any,
  editing: PropTypes.any,
  placeholder: PropTypes.string,
  onUpdate: PropTypes.func
}

Tag.defaultProps = {
  editing: false,
  placeholder: 'Add tag'
}

export default Tag
